import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44dd5ecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cos-view-content-header"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "cos-view-content-header-list" }
const _hoisted_5 = { class: "cos-view-content-header-label" }
const _hoisted_6 = { class: "cos-view-content-header-name" }
const _hoisted_7 = { class: "cos-view-content-header-list" }
const _hoisted_8 = { class: "cos-view-content-header-label" }
const _hoisted_9 = { class: "cos-view-content-header-name" }
const _hoisted_10 = {
  key: 0,
  class: "header-list"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cos-view-content-header-label" }, "历史最高客户阶段", -1))
const _hoisted_12 = { class: "cos-view-content-header-name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cos-view-content-header-line" }, null, -1))

import { useI18n } from 'vue-i18n'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  sellerName: String,
  title: String,
  collectionId: String,
  header: Boolean,
  customLabel: String,
  customValue: String,
  turnedContract: String, // 转签约客户时间
  turnedPotential: String, // 转潜在客户时间
  turnedTransaction: String, // 转成交时间
  addFav: Function,
  cancelFav: Function,
  view: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const { t } = useI18n()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'cos-view-content': __props.view, 'cos-no-header': !__props.header })
  }, [
    _renderSlot(_ctx.$slots, "header", {}, () => [
      (__props.header)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", null, _toDisplayString(__props.title), 1),
              (__props.collectionId===null)
                ? (_openBlock(), _createBlock(FavoriteIcon, {
                    key: 0,
                    type: "add",
                    "is-detail": "true",
                    onClick: __props.addFav
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createBlock(FavoriteIcon, {
                    key: 1,
                    type: "cancel",
                    "is-detail": "true",
                    onClick: __props.cancelFav
                  }, null, 8, ["onClick"]))
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('custom.followBy')), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(__props.sellerName || '--'), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(__props.customLabel), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(__props.customValue || '--'), 1)
              ]),
              (__props.turnedContract || __props.turnedPotential || __props.turnedTransaction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(__props.turnedTransaction ? `成交客户(${__props.turnedTransaction})` : (__props.turnedContract ? `签约客户(${__props.turnedContract})` : (__props.turnedPotential ? `潜在客户(${__props.turnedPotential})` : '--'))), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_13
          ]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})